import React from 'react';

const NotFoundPage = () => <h1>NOT FOUND</h1>;

export default NotFoundPage;
